import React, { createContext, useContext, useState, useMemo } from 'react';

const FormStepContext = createContext();

export const useFormStep = () => {
  const context = useContext(FormStepContext);
  if (!context) {
    return {
      formStep: null,
      setFormStep: () => {},
      listingMode: null,
      setListingMode: () => {},
      showVariantsTab: false,
      setShowVariantsTab: () => {},
      isThemesPanelOpen: false,
      setIsThemesPanelOpen: () => {},
      selectedTheme: null,
      setSelectedTheme: () => {},
      handleThemeSelect: () => {},
      setHandleThemeSelect: () => {},
      showResultPopup: false,
      setShowResultPopup: () => {},
      showBothSidebars: false,
      setShowBothSidebars: () => {},
      isFontsPanelOpen: false,
      setIsFontsPanelOpen: () => {},
      selectedFonts: { headerFont: { family: '', weight: '' }, calloutTextFont: { family: '', weight: '' }, bodyFont: { family: '', weight: '' } },
      setSelectedFonts: () => {},
      // Bulk listing SKU selector
      bulkSkuData: null,
      setBulkSkuData: () => {},
      onBulkSkuClick: () => {},
      setOnBulkSkuClick: () => {},
      applyThemeToAll: false,
      setApplyThemeToAll: () => {}
    };
  }
  return context;
};

export const FormStepProvider = ({ children }) => {
  const [formStep, setFormStep] = useState(null);
  const [listingMode, setListingMode] = useState(null);
  const [showVariantsTab, setShowVariantsTab] = useState(false);
  const [isThemesPanelOpen, setIsThemesPanelOpen] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [handleThemeSelect, setHandleThemeSelect] = useState(() => () => {});
  const [showResultPopup, setShowResultPopup] = useState(false);
  const [showBothSidebars, setShowBothSidebars] = useState(false);
  const [isFontsPanelOpen, setIsFontsPanelOpen] = useState(false);
  const [selectedFonts, setSelectedFonts] = useState({
    headerFont: { family: '', weight: '' },
    calloutTextFont: { family: '', weight: '' },
    bodyFont: { family: '', weight: '' }
  });

  // Bulk listing SKU selector
  const [bulkSkuData, setBulkSkuData] = useState(null);
  const [onBulkSkuClick, setOnBulkSkuClick] = useState(() => () => {});
  const [applyThemeToAll, setApplyThemeToAll] = useState(false);

  const value = useMemo(() => ({
    formStep,
    setFormStep,
    listingMode,
    setListingMode,
    showVariantsTab,
    setShowVariantsTab,
    isThemesPanelOpen,
    setIsThemesPanelOpen,
    selectedTheme,
    setSelectedTheme,
    handleThemeSelect,
    setHandleThemeSelect,
    showResultPopup,
    setShowResultPopup,
    showBothSidebars,
    setShowBothSidebars,
    isFontsPanelOpen,
    setIsFontsPanelOpen,
    selectedFonts,
    setSelectedFonts,
    bulkSkuData,
    setBulkSkuData,
    onBulkSkuClick,
    setOnBulkSkuClick,
    applyThemeToAll,
    setApplyThemeToAll,
  }), [
    formStep, listingMode, showVariantsTab, isThemesPanelOpen,
    selectedTheme, handleThemeSelect, showResultPopup, showBothSidebars,
    isFontsPanelOpen, selectedFonts, bulkSkuData, onBulkSkuClick, applyThemeToAll,
  ]);

  return (
    <FormStepContext.Provider value={value}>
      {children}
    </FormStepContext.Provider>
  );
};

